// extracted by mini-css-extract-plugin
export var option = "_5w-0";
export var optionCard = "_5w-f";
export var optionContent = "_5w-g";
export var optionIcon = "_5w-i";
export var optionIconBox = "_5w-h";
export var optionLabel = "_5w-j";
export var optionPill = "_5w-m";
export var optionPillBadge = "_5w-p";
export var optionPillIcon = "_5w-n";
export var optionPillLabel = "_5w-o";
export var optionRadio = "_5w-k";
export var optionRadioInner = "_5w-l";
export var optionReveal = "_5w-2";
export var optionRevealDelay0 = "_5w-3";
export var optionRevealDelay1 = "_5w-4";
export var optionRevealDelay10 = "_5w-d";
export var optionRevealDelay11 = "_5w-e";
export var optionRevealDelay2 = "_5w-5";
export var optionRevealDelay3 = "_5w-6";
export var optionRevealDelay4 = "_5w-7";
export var optionRevealDelay5 = "_5w-8";
export var optionRevealDelay6 = "_5w-9";
export var optionRevealDelay7 = "_5w-a";
export var optionRevealDelay8 = "_5w-b";
export var optionRevealDelay9 = "_5w-c";
export var optionSelected = "_5w-1";